import { Plus } from "lucide-react";
import { cn } from "@/lib/utils";
import { CategoryNavProps } from "./types";
import { useTranslations } from "next-intl";

export function CategoryNav({
  menu,
  language,
  activeCategory,
  onCategoryClick,
  onAddCategory,
  variant = "default",
  isEditable = false,
  isRTL = false,
}: CategoryNavProps) {
  const t = useTranslations("CategoryNav");

  return (
    <nav
      className={cn(
        "flex min-w-max",
        variant === "default"
          ? "-mx-4 lg:mx-0 lg:flex-col lg:p-4 w-[calc(100%+32px)]"
          : "flex-col",
        variant === "sheet" && isRTL && "items-end"
      )}
    >
      {menu.categories.map((category) => {
        const categoryId = `category-${category.id}`;
        return (
          <button
            key={category.id}
            onClick={() => onCategoryClick(categoryId)}
            className={cn(
              "whitespace-nowrap transition-colors",
              isRTL ? "text-right" : "text-left",
              variant === "default"
                ? "h-[46px] px-4 text-sm border-b-[3px] border-transparent flex items-center lg:h-auto lg:py-3 lg:px-5 lg:border-b-0 lg:border-l-[3px]"
                : "w-full text-base p-3",
              activeCategory === categoryId
                ? variant === "default"
                  ? "border-primary lg:border-b-0 lg:border-l-primary font-bold lg:bg-primary/5 dark:lg:bg-primary/10 text-primary dark:text-primary"
                  : "font-bold text-primary dark:text-primary"
                : variant === "default"
                ? "hover:border-primary/50 lg:hover:border-b-0 lg:hover:border-l-primary/50 hover:text-primary/90 dark:hover:text-primary/90"
                : "text-muted-foreground hover:text-primary/90 dark:hover:text-primary/90"
            )}
          >
            {category.name[language] || category.name.japanese}
          </button>
        );
      })}
      {isEditable && variant === "default" ? (
        <button
          onClick={onAddCategory}
          className={cn(
            "hidden lg:flex items-center gap-2 text-sm text-muted-foreground hover:text-[var(--brand)] dark:hover:text-[var(--brand)] transition-colors px-5 py-3 mt-2",
            isRTL && "justify-end"
          )}
        >
          <Plus className={cn("h-4 w-4", isRTL && "order-last ml-2 mr-0")} />
          {t("addCategory")}
        </button>
      ) : isEditable ? (
        <button
          onClick={onAddCategory}
          className={cn(
            "flex items-center gap-2 text-base text-muted-foreground hover:text-[var(--brand)] dark:hover:text-[var(--brand)] transition-colors p-3",
            isRTL && "justify-end"
          )}
        >
          <Plus className={cn("h-4 w-4", isRTL && "order-last ml-2 mr-0")} />
          {t("addCategory")}
        </button>
      ) : null}
    </nav>
  );
}

export default CategoryNav;
